const EMAIL_REGEXP = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const SNACKBAR_TIMEOUT = 5000;

export {
  EMAIL_REGEXP,
  SNACKBAR_TIMEOUT,
}
